import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    height: 100%;
    background-color: ${props => props.theme.backgroundColor};
}
`;
